window.theme = window.theme || {};

(function() {
    /** 
     * Truncation of the PDP description until the customer clicks the read more link to expand it
     */
    theme.truncateDescription = function() {
        var $read_more_link  = $('<a href="#show-more" class="button button--link-style">Read More</a>');
        var $pdp_description = $('.product__information .truncate');

        if ($pdp_description.children().length > 1) {
            $pdp_description.find(' > *:not(:first-child)').hide();
            $read_more_link.appendTo( $pdp_description );

            $read_more_link.on('click', function(e) {
                e.preventDefault();
                $pdp_description.find(' > *').show();
                $read_more_link.remove();
            });
        }
    };

    theme.truncateDescription();

    /**
     * Fix for the sticky header when the orientation on tablet changes from portrait to landscape
     */
    theme.tabletHeaderFix = function() {
        $(window).on('resize', function() {
            if (isScreenSizeLarge()) {
                Shopify.theme.jsHeader.enableSticky();
            }
        });
    };

    theme.tabletHeaderFix();

    /**
     * Fix for the instant search suggestions not closing when closing the search bar
     */
    theme.searchSuggestionFix = function() {
        $('.close-search').on('click', function() {
            $('.boost-pfs-search-suggestion-wrapper').removeClass('boost-pfs-search-suggestion-open');
        });
    };

    theme.searchSuggestionFix();

    /**
     * Collection swatch fix
     */
    theme.collectionSwatchesFix = function() {
        $('.thumbnail-swatch .swatch__image').each(function(){
            $(this).parent().css('background-image', 'url("'+ $(this).attr('src') +'")');
        });
    };

    $(window).on('load', function() {
        theme.collectionSwatchesFix();
    });

    /**
     * Dynamic Header Wrapping
     */
    theme.dynamicHeaderWrapping = function() {
        var $header = $('#header');

        var $navbar     = $header.find('.navbar'),
            $logo       = $header.find('.header__brand'),
            $menu_items = $header.find('.navbar-item'),
            $icons      = $header.find('.header__icons');

        var navbar_w = 0,
            logo_w = 0,
            menu_w = 0,
            icons_w = 0;

        var header_wrap_class = 'header--wrapped';

        function reCalcHeader () {
            if (isScreenSizeLarge()) {
                navbar_w = $navbar.outerWidth();
                logo_w   = $logo.outerWidth();
                menu_w   = 20; // add some extra padding for our calculation
                icons_w  = $icons.outerWidth();

                $menu_items.each(function(){
                    menu_w += $(this).outerWidth();
                });

                if (menu_w >= (navbar_w - logo_w - icons_w)) {
                    $header.addClass(header_wrap_class);
                    $menu_items.css('opacity', 1);
                }
                else {
                    $header.removeClass(header_wrap_class);
                    $menu_items.css('opacity', 1);
                }
            }
        }

        $menu_items.css('opacity', 0);
        $(window).on('resize', reCalcHeader);
        $(window).on('load', reCalcHeader);
    };

    theme.dynamicHeaderWrapping();

    /**
     * Product Form Extension
     */
    theme.productForm = function () {
        var productPriceTemplate = '<span class="price" data-price><span class="money" data-price>{{LABEL}}</span></span>';

        var selectors = {
            'price': '.price-ui',
            'atc': '#AddToCart',
            'variant': '[data-variant-selection]'
        };

        var labels = {
            'soldout': 'Sold Out',
            'unavailable': 'Unavailable'
        };

        function updateProductForm() {
            setTimeout(function(){
                // remove variant url parameter (this does not work well with Klaviyo)
                window.history.replaceState(null, null, window.location.pathname);
    
                if ($(selectors.atc).length == 0 || $(selectors.atc).hasClass('disabled')) {
                    if ($(selectors.variant).attr('variant') === 'unavailable') {
                        $(selectors.price).html(productPriceTemplate.replace('{{LABEL}}', labels.unavailable));
                    }
/*                    else {
                        $(selectors.price).html(productPriceTemplate.replace('{{LABEL}}', labels.soldout));
                    }*/
                }
            }, 10); // need a slight delay to do this after the theme calculates price
        }

        if ($('body').hasClass('product')) {
            updateProductForm();
            $('[data-variant-selection]').on('variant-change', updateProductForm);
        }
    };

    $(window).on('load', function() {
        theme.productForm();
    });
})();
